import React from 'react';
import { Form, Radio } from 'antd';
import GenericDialog from '@common/GenericDialog';

const EditTestDialog = ({
                            open,
                            onClose,
                            useWizardForm,
                            onEditTestConfirm,
                            onEditTestRadioChange,
                            defaultUseWizard = true,
                        }) => {
    return (
        <GenericDialog
            title="Edit Test"
            open={open}
            onClose={() => {
                onClose();
                useWizardForm.resetFields();
            }}
            buttons={[
                {
                    name: 'Cancel',
                    extraProps: { type: 'text' },
                },
                {
                    name: 'Edit',
                    callback: () => {
                        onEditTestConfirm();
                    },
                },
            ]}
            contentStyle={{ width: 400 }}
        >
            {/* If you need some explanation text, place it here */}
            <Form
                form={useWizardForm}
                initialValues={{ useWizard: defaultUseWizard }}
            >
                <Form.Item
                    label="How to add questions"
                    name="useWizard"
                    labelCol={{ span: 11 }}
                >
                    <Radio.Group
                        options={[
                            { label: 'Manual', value: false },
                            { label: 'Wizard', value: true },
                        ]}
                        optionType="button"
                        onChange={onEditTestRadioChange}
                        buttonStyle={'solid'}
                    />
                </Form.Item>
            </Form>
        </GenericDialog>
    );
};

export default EditTestDialog;
